module.exports = "/_next/static/images/3-e6d3f8493421717f59487029b4daf285.png";